// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2hPln","assignButton":"CreateEditEquipmentSchedule_assignButton__3cHji"};